export const SOFTWAREFLAG = 'PASSPORT_SOFTWARE';
